var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { updateSettings } from '../services/IpAssistantService';
import { ipAssistantKeys } from './queryKeys';
const namespace = 'features.settings.ip_assistant';
export function useUpdateIpAssistantSettings() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload) => updateSettings(payload),
        onMutate: (payload) => __awaiter(this, void 0, void 0, function* () {
            yield queryClient.cancelQueries({ queryKey: ipAssistantKeys.settings() });
            const previousData = queryClient.getQueryData(ipAssistantKeys.settings());
            if (previousData) {
                const updatedData = Object.assign({}, previousData);
                if (payload.ai_office_enabled !== undefined) {
                    updatedData.aiOfficeEnabled = payload.ai_office_enabled;
                }
                if (payload.ip_assistant_allowed_user_ids !== undefined) {
                    updatedData.ipAssistantAllowedUserIds = payload.ip_assistant_allowed_user_ids;
                }
                if (payload.ip_assistant_allowed_technician_ids !== undefined) {
                    updatedData.ipAssistantAllowedTechnicianIds = payload.ip_assistant_allowed_technician_ids;
                }
                queryClient.setQueryData(ipAssistantKeys.settings(), updatedData);
            }
            return { previousData };
        }),
        onError: (error, _variables, context) => {
            if (context === null || context === void 0 ? void 0 : context.previousData) {
                queryClient.setQueryData(ipAssistantKeys.settings(), context.previousData);
            }
            const message = (error === null || error === void 0 ? void 0 : error.message) || translate('update_error', { namespace });
            toast.error(message);
        },
        onSuccess: () => {
            toast.success(translate('update_success', { namespace }));
        },
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey: ipAssistantKeys.settings() });
            void queryClient.invalidateQueries({ queryKey: ipAssistantKeys.all });
        }
    });
}
